import { ReactNode } from "react";

export const isFirstToast = ({
    allowCloseAll,
    toastContent,
    toastStack,
}: {
    allowCloseAll: boolean;
    toastStack: { content: ReactNode }[];
    toastContent: ReactNode;
}) => allowCloseAll && toastStack.length > 1 && toastStack.findIndex((t) => t.content === toastContent) === 0;
